import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";

export const CHATBOT_ANALYTICS_NAMESPACE = "s/chatbot";

export type ChatbotSessionAnalyticsPayload = {
  chatbotSessionId: string;
  image?: string;
  text?: string;
  moduleType?: string;
};

export function logPromptShown(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/PROMPT_SHOWN`,
    payload
  });
}

export function logPromptClicked(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/PROMPT_CLICKED`,
    payload
  });
}

export function logRecommendationClick(
  payload: ChatbotSessionAnalyticsPayload
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/RECOMMENDATION_CLICKED`,
    payload
  });
}

export function logGatingMessageShown(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/GATING_MESSAGE_SHOWN`,
    payload
  });
}

export function logGatedAskParents(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/GATED_ASK_PARENTS`,
    payload
  });
}

export function logGatedCTAClick(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/GATED_CTA_CLICK`,
    payload
  });
}

export function logSendClicked(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/SEND_CLICKED`,
    payload
  });
}

export function logInappropriateRequest(
  payload: ChatbotSessionAnalyticsPayload
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/INAPPROPRIATE_REQUEST`,
    payload
  });
}

export function logLandingPageVisit(payload: ChatbotSessionAnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/LANDING_PAGE_VISIT`,
    payload
  });
}

export function logImageUploadIconClicked(
  payload: Omit<ChatbotSessionAnalyticsPayload, "text">
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/IMG_UPLOAD_ICON_CLICKED`,
    payload
  });
}

export function logUserUploadedImage(
  payload: Omit<ChatbotSessionAnalyticsPayload, "text">
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/IMG_UPLOADED_TO_STORE`,
    payload
  });
}

export function logUserSelectedPastChat(
  payload: Omit<ChatbotSessionAnalyticsPayload, "text">
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/PAST_CHAT_SELECTED`,
    payload: { ...payload }
  });
}

export function logUserRenamedChat(
  payload: Omit<ChatbotSessionAnalyticsPayload, "text">
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/CHAT_RENAMED`,
    payload: { ...payload }
  });
}

export function logUserDeletedChat(
  payload: Omit<ChatbotSessionAnalyticsPayload, "text">
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/CHAT_DELETED`,
    payload: { ...payload }
  });
}

export function logStartAmeliaDictation(
  payload: Omit<ChatbotSessionAnalyticsPayload, "text">
) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/START_DICTATION`,
    payload
  });
}

// feedback
export function logUserFeedbackOnChatbotResponse(feedback: string) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${CHATBOT_ANALYTICS_NAMESPACE}/USER_FEEDBACK`,
    payload: { value: feedback }
  });
}
